<template>
  <div>

    <div class="title-section">
      <div class="display-1 font-weight-bold">{{meta.title}}</div>
      <div class="subheading">{{meta.subtitle}}</div>
    </div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Texturing!</div><v-divider class="div-after"/>
    <div class="body-1">
      Another small update showing off some basic reflection. 
    </div>
    <v-img class="u-image" :src="require(`../assets/updates/8/reflection.png`)"/>
      <div class="font-weight-medium">Basic Reflection</div>
    <v-img class="u-image" :src="require(`../assets/updates/8/reflection_2.png`)"/>
      <div class="font-weight-medium">Slightly Adjusted Parameters</div>


  </div>
</template>

<script>
import CardList from '../components/CardList';

export default {
  name: 'U_8',
  components: { CardList, },
  data() {
    return {
    };
  },
  computed: {
    meta() {
      return this.$store.state.updates[8];
    },
  },
}
</script>

<style>

</style>
